<div class="footer">
    <a
        id="code-of-conduct"
        href="https://static.mlh.io/docs/mlh-code-of-conduct.pdf"
        target="_blank"
        rel="noopener"
    >
        mlh code of conduct
    </a>
    | ©2021 VandyHacks
    <br />
    <br />
    this site is powered by
    <a href="https://netlify.com" target="_blank" rel="noopener">netlify</a>
</div>
<div class="socials">
    <!-- Instagram Icon -->
    <a
        id="instagram-container"
        href="https://www.instagram.com/vandyhacks/"
        target="_blank"
        rel="noopener"
    >
        <svg id="instagram" viewBox="0 0 24 24" alt="instagram icon">
        <path
            fill="currentColor"
            d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
        />
        </svg>
    </a>
    <!-- Youtube Icon -->
    <a
        id="youtube-container"
        href="https://www.youtube.com/channel/UC-sXkznjkmHLjpA5nlfdswg/"
        target="_blank"
        rel="noopener"
    >
        <svg id="youtube" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
        />
        </svg>
    </a>
    <!-- Facebook Icon -->
    <a
        id="facebook-container"
        href="https://www.facebook.com/vandyhacks/"
        target="_blank"
        rel="noopener"
    >
        <svg id="facebook" viewBox="0 0 24 24" alt="facebook icon">
        <path
            fill="currentColor"
            d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z"
        />
        </svg>
    </a>
    <!-- Twitter Icon -->
    <a
        id="twitter-container"
        href="https://twitter.com/vandyhacks"
        target="_blank"
        rel="noopener"
    >
        <svg id="twitter" viewBox="0 0 24 24" alt="twitter icon">
        <path
            fill="currentColor"
            d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z"
        />
        </svg>
    </a>
    <!-- Twitch Icon -->
    <a
        id="twitch-container"
        href="https://www.twitch.tv/vandyhacks"
        target="_blank"
        rel="noopener"
    >
        <svg id="twitch" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M11.64 5.93H13.07V10.21H11.64M15.57 5.93H17V10.21H15.57M7 2L3.43 5.57V18.43H7.71V22L11.29 18.43H14.14L20.57 12V2M19.14 11.29L16.29 14.14H13.43L10.93 16.64V14.14H7.71V3.43H19.14Z"
        />
        </svg>
    </a>
    <!-- Github Icon -->
    <a
        id="github-container"
        href="https://github.com/VandyHacks"
        target="_blank"
        alt="github icon"
    >
        <svg id="github" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M12,2A10,10 0 0,0 2,12C2,16.42 4.87,20.17 8.84,21.5C9.34,21.58 9.5,21.27 9.5,21C9.5,20.77 9.5,20.14 9.5,19.31C6.73,19.91 6.14,17.97 6.14,17.97C5.68,16.81 5.03,16.5 5.03,16.5C4.12,15.88 5.1,15.9 5.1,15.9C6.1,15.97 6.63,16.93 6.63,16.93C7.5,18.45 8.97,18 9.54,17.76C9.63,17.11 9.89,16.67 10.17,16.42C7.95,16.17 5.62,15.31 5.62,11.5C5.62,10.39 6,9.5 6.65,8.79C6.55,8.54 6.2,7.5 6.75,6.15C6.75,6.15 7.59,5.88 9.5,7.17C10.29,6.95 11.15,6.84 12,6.84C12.85,6.84 13.71,6.95 14.5,7.17C16.41,5.88 17.25,6.15 17.25,6.15C17.8,7.5 17.45,8.54 17.35,8.79C18,9.5 18.38,10.39 18.38,11.5C18.38,15.32 16.04,16.16 13.81,16.41C14.17,16.72 14.5,17.33 14.5,18.26C14.5,19.6 14.5,20.68 14.5,21C14.5,21.27 14.66,21.59 15.17,21.5C19.14,20.16 22,16.42 22,12A10,10 0 0,0 12,2Z"
        />
        </svg>
    </a>
</div>

<style>

.footer, .socials {
    z-index: 5;
}
.footer {
    /* margin-bottom: 1vh; */
    font-size: 0.6rem;
    position: absolute;
    width: 100vw;
    font-family: 'Montserrat';

    align-items: center;
    justify-content: center;
    text-align: center;

    position: absolute;
    width: 100vw;
    top: calc(86vh + 60px);
    line-height: 0.6rem;
}

.footer a {
    text-decoration: none;
    color: #f9a602;
}

.footer a:hover {
    font-weight: bold;
}

.footer {
    height: 50px;
    margin-top: auto;
}

.socials {
    min-height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: absolute;
    min-width: 100vw;
    top: 86vh;
}

.socials svg {
    width: 24px;
    height: 24px;
    border-radius: 14%;
    transition: transform 0.1s ease-in-out;
    overflow: hidden;
}

.socials a {
    text-decoration: none;
    border-radius: 25%;
    color: white;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 9px;
    width: 32px;
    height: 32px;
}

#facebook-container:hover {
    transition: all 0.1s ease-in-out;
    transform: scale(1.1);
    background-color: white;
    color: #355998;
}

#instagram-container:hover {
    transition: all 0.1s ease-in-out;
    transform: scale(1.1);
    background: linear-gradient(
        45deg,
        #f09433 0%,
        #e6683c 25%,
        #dc2743 50%,
        #cc2366 75%,
        #bc1888 100%
    );
    color: white;
}

#github-container:hover {
    transition: all 0.1s ease-in-out;
    transform: scale(1.1);
    color: #121212;
    background: white;
}

#twitter-container:hover {
    transition: all 0.1s ease-in-out;
    transform: scale(1.1);
    background: #00acee;
    color: white;
}

#twitch-container:hover {
    transition: all 0.1s ease-in-out;
    transform: scale(1.1);
    background: #fff;
    color: #6441a5;
}

#youtube-container:hover {
    transition: all 0.1s ease-in-out;
    transform: scale(1.1);
    background: #ff0000;
    color: white;
}

@media only screen and (max-width: 420px) {
  .socials {
    padding: 0% 1%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /* margin-top: 20px; */
    overflow-y: hidden;
  }
  .socials a {
    margin: 0 5px;
    width: 29px;
    height: 29px;
  }
  .socials svg {
    width: 24px;
    height: 24px;
  }
  .footer {
    font-size: 0.7rem;
    top: calc(86vh + 45px);
  }
}

</style>